import { colors } from "@material-ui/core";

import { ConfigureDestinationsModal } from "@/destinations/modals/ConfigureDestinationsModal.jsx";
import { DestinationConfigRow } from "../shared/ConfigPageRow";

const AdvertiserIDModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={["advertiserId"]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const AdvertiserIDRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const idSet = "advertiserId" in settings;

  return (
    <DestinationConfigRow
      name="Advertiser ID"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("advertiserId")}
    />
  );
};

const GraphQLAPITokenModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={["graphQLAPIToken"]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const GraphQLAPITokenRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const idSet = "graphQLAPIToken" in settings;

  return (
    <DestinationConfigRow
      name="GraphQL API Token"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const ADVERTISER_ID = "ADVERTISER_ID";
const GRAPHQL_API_TOKEN = "GRAPHQL_API_TOKEN";

const Rows = {
  [ADVERTISER_ID]: AdvertiserIDRow,
  [GRAPHQL_API_TOKEN]: GraphQLAPITokenRow,
};

const Modals = {
  [ADVERTISER_ID]: AdvertiserIDModal,
  [GRAPHQL_API_TOKEN]: GraphQLAPITokenModal,
};

const RowOrder = [ADVERTISER_ID, GRAPHQL_API_TOKEN];

const config = {
  Rows,
  RowOrder,
  Modals,
};

export default config;
